import script from "./tickets-filter-sort-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tickets-filter-sort-menu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__